import { ChunkAndMapSequentialParams } from './types/array.utils.types';

export class ArrayUtil {
  static chunk<T>(array: T[], size: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  static paginate<T>(array: T[], skip: number, limit: number): T[] {
    return array.slice(skip, skip + limit);
  }

  static getAsArray<T>(value: T | T[]): T[] {
    if (Array.isArray(value)) {
      return value;
    }
    return [value];
  }

  static async chunkAndMapSequential<T, R>({
    items,
    chunkSize,
    mapper,
  }: ChunkAndMapSequentialParams<T, R>): Promise<R[]> {
    const chunks = ArrayUtil.chunk(items, chunkSize);
    const results: R[] = [];

    for (const chunk of chunks) {
      const resolvedChunk = await Promise.all(chunk.map(mapper));
      for (const item of resolvedChunk) {
        item && results.push(item);
      }
    }

    return results;
  }
}
